import React from 'react'
import { connect } from 'react-redux'
import { submit, isPristine, isValid } from 'redux-form'
import { Submitting } from '../common/Submitting'

const SaveAndCancelButtons = ({
  changePersonalInfoEditingMode,
  submitting,
  dispatch,
  pristine,
  valid,
  formName
}) => (
  <div className="col-xs-6 center-xs end-xs">
    <button
      style={{ marginRight: '12px' }}
      className="link cancel"
      onClick={() => changePersonalInfoEditingMode(false)}
    >
      Cancel
    </button>
    {submitting ? (
      <Submitting />
    ) : (
      <button
        className="primary"
        disabled={!valid || pristine}
        type="submit"
        onClick={() => dispatch(submit(formName))}
      >
        Save Changes
      </button>
    )}
  </div>
)
const mapStateToProps = (state, ownProps) => ({
  valid: isValid(ownProps.formName)(state),
  pristine: isPristine(ownProps.formName)(state)
})

export default connect(mapStateToProps)(SaveAndCancelButtons)
